/**
 * PLAN-010 Phase 7: Admin API Service
 */
import api from "./axiosInstance";

const BASE = "/admin";

// ── User Management ─────────────────────────────────────────────────────
export const createUser = async (body) => {
  const { data } = await api.post(`${BASE}/users`, body);
  return data;
};

export const getUsers = async (params = {}) => {
  const { data } = await api.get(`${BASE}/users`, { params });
  return data;
};

export const getUserById = async (id) => {
  const { data } = await api.get(`${BASE}/users/${id}`);
  return data;
};

export const updateUser = async (id, body) => {
  const { data } = await api.patch(`${BASE}/users/${id}`, body);
  return data;
};

export const updateUserStatus = async (id, isActive) => {
  const { data } = await api.patch(`${BASE}/users/${id}/status`, { isActive });
  return data;
};

export const updateUserRoles = async (id, roles) => {
  const { data } = await api.patch(`${BASE}/users/${id}/roles`, { roles });
  return data;
};

export const deleteUser = async (id) => {
  const { data } = await api.delete(`${BASE}/users/${id}`);
  return data;
};

export const adminResetPassword = async (id, password) => {
  const { data } = await api.patch(`${BASE}/users/${id}/reset-password`, { password });
  return data;
};

// ── Analytics ───────────────────────────────────────────────────────────
export const getStats = async () => {
  const { data } = await api.get(`${BASE}/stats`);
  return data;
};

// ── Feature Flags ───────────────────────────────────────────────────────
export const getFeatureFlags = async () => {
  const { data } = await api.get(`${BASE}/features`);
  return data;
};

export const createFeatureFlag = async (body) => {
  const { data } = await api.post(`${BASE}/features`, body);
  return data;
};

export const updateFeatureFlag = async (id, body) => {
  const { data } = await api.patch(`${BASE}/features/${id}`, body);
  return data;
};

export const deleteFeatureFlag = async (id) => {
  const { data } = await api.delete(`${BASE}/features/${id}`);
  return data;
};

// ── Permissions ─────────────────────────────────────────────────────────
export const getPermissions = async () => {
  const { data } = await api.get(`${BASE}/permissions`);
  return data;
};

export const updatePermissions = async (role, permissions) => {
  const { data } = await api.patch(`${BASE}/permissions/${role}`, { permissions });
  return data;
};

// ── Email Verification ──────────────────────────────────────────────────
export const setEmailVerified = async (id, verified) => {
  const { data } = await api.patch(`${BASE}/users/${id}/verify-email`, { verified });
  return data;
};

// ── Audit Logs ──────────────────────────────────────────────────────────
export const getAuditLogs = async (params = {}) => {
  const { data } = await api.get(`${BASE}/audit-logs`, { params });
  return data;
};

// ── Appointments ────────────────────────────────────────────────────────
export const getAdminAppointments = async (params = {}) => {
  const { data } = await api.get(`${BASE}/appointments`, { params });
  return data;
};

export const getAppointmentStats = async () => {
  const { data } = await api.get(`${BASE}/appointments/stats`);
  return data;
};

// ── Enhanced Stats ──────────────────────────────────────────────────────
export const getEnhancedStats = async () => {
  const { data } = await api.get(`${BASE}/stats/enhanced`);
  return data;
};

// ── Broadcast Notification ──────────────────────────────────────────────
export const broadcastNotification = async (body) => {
  const { data } = await api.post(`${BASE}/notifications/broadcast`, body);
  return data;
};

// ── Role Switching (user endpoints) ─────────────────────────────────────
export const switchRole = async (activeRole) => {
  const { data } = await api.patch("/user/switch-role", { activeRole });
  return data;
};

export const getUserFeatures = async () => {
  const { data } = await api.get("/user/features");
  return data;
};
